import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurationStatuses } from '@api/ruConfigurations';

import { optionsFormatted } from '@utils/formatter';

import { TNameTitleColor } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS_STATUSES } from '@constants/queryKeys';

interface IUseQueryRUConfigurationStatusesReturned {
	ruConfigurationStatuses: TSelectOption<string>[];
	isLoadingRUConfigurationStatuses: boolean;
}

export const useQueryRUConfigurationStatuses = (): IUseQueryRUConfigurationStatusesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TNameTitleColor[], TSelectOption<string>[]>({
		queryKey: [RU_CONFIGURATIONS_STATUSES],
		queryFn: getRUConfigurationStatuses,
		select: (data) => optionsFormatted(data),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurationStatuses: data || [],
		isLoadingRUConfigurationStatuses: isInitialLoading,
	};
};
